import React, { createContext, useContext } from 'react';
import { useUser,useSignOut } from '../api/user';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { user, loading } = useUser();
  const { mutate: signOut } = useSignOut();

  const handleSignOut = () => {
    signOut(null, {
      onSuccess: () => {
        window.location.href = '/login'; // Redirect to login after sign out
      },
      onError: (error) => {
        alert(`Error signing out: ${error.message}`);
      },
    });
  };

  return (
    <AuthContext.Provider value={{ user, loading, signOut: handleSignOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);